export const content = {
    domain: "Check N Go",
    footer: "checksndgo.com",
    title1: "Find The Right Loan For you!",
  };
  